<ng-select [items]="model.items$()"
           [(ngModel)]="model.selectedItems$"
           [multiple]="!model.config$().singleSelection"
           [dropdownPosition]="'auto'"
           [virtualScroll]="true"
           [disabled]="disabled()"
           [bindLabel]="'label'"
           [bindValue]="'value'"
           [appendTo]="'body'"
           (scrollToEnd)="scrollToEnd()"
           (search)="search($event)">
</ng-select>

